import { render, staticRenderFns } from "./editAgent.vue?vue&type=template&id=5b33e09c&"
import script from "./editAgent.vue?vue&type=script&lang=js&"
export * from "./editAgent.vue?vue&type=script&lang=js&"
import style0 from "./editAgent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports